import React, { useMemo } from 'react';
import { useRegion } from '../context/RegionContext';
import './RegionTransition.css';

const COUNT = 70;

const RegionTransition = () => {
  const { transitioning, region } = useRegion();

  // Generate random small squares each time a transition starts.
  const squares = useMemo(() => {
    return Array.from({ length: COUNT }).map(() => {
      const size = 3 + Math.random() * 9; // 3px–12px tiny squares
      return {
        top: Math.random() * 100,
        size,
        delay: Math.random() * 0.35,
        duration: 1.1 + Math.random() * 0.5,
        opacity: 0.5 + Math.random() * 0.5,
      };
    });
    // re-generate whenever a new transition fires
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transitioning, region]);

  if (!transitioning) return null;

  return (
    <div className="region-transition" aria-hidden="true">
      {squares.map((s, i) => (
        <span
          key={i}
          className="rt-square"
          style={{
            top: `${s.top}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            opacity: s.opacity,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
          }}
        />
      ))}
    </div>
  );
};

export default RegionTransition;
